import { type FC } from 'react';
import { type Color, type ColorlessIconProps } from '@direct-frontend/components';
import { type OpenApiSchemaPriceIndexSignal } from '../../api/schema';
import { IconSignalHigh } from '../../ui/icons/IconSignalHigh';
import { IconSignalLow } from '../../ui/icons/IconSignalLow';
import { IconSignalMiddle } from '../../ui/icons/IconSignalMiddle';

export const MAP_INDEX_PRICE_ICON_COLOR: {
    [Signal in OpenApiSchemaPriceIndexSignal]: Extract<Color, 'red' | 'orange' | 'green' | 'gray'>;
} = {
    no_data: 'gray',
    bad_data: 'gray',
    low: 'green',
    medium: 'orange',
    high: 'red',
};

export const MAP_INDEX_PRICE_ICON: { [Signal in OpenApiSchemaPriceIndexSignal]: FC<ColorlessIconProps> } = {
    no_data: IconSignalHigh,
    bad_data: IconSignalHigh,
    low: IconSignalLow,
    medium: IconSignalMiddle,
    high: IconSignalHigh,
};

export const MAP_INDEX_PRICE_TITLE: { [Signal in OpenApiSchemaPriceIndexSignal]: string } = {
    no_data: 'Нет данных о цене на другой площадке',
    bad_data: 'Ждём обновления цены',
    low: 'Выгодная цена товара',
    medium: 'Цена товара на уровне другой площадки',
    high: 'Цена товара выше, чем на другой площадке',
};
